import $ from 'jquery'

var memoryCache = {}

function getWithInMemoryCache (url, options) {
  var defered = $.Deferred()
  var cacheKey = url + JSON.stringify(options)
  if (memoryCache[cacheKey]) {
    defered.resolve(memoryCache[cacheKey])
  } else {
    $.get(url, options.data).done(function (data) {
      memoryCache[cacheKey] = data
      defered.resolve(data)
    })
  }
  return defered.promise().done(function (data) {
    if (options.success) options.success(data)
    return data
  })
}

getWithInMemoryCache.clearCache = function () {
  memoryCache = {}
}

export default getWithInMemoryCache
